import { Component, OnInit, Inject } from '@angular/core'
import { Channel, ActionFailed } from '@tokeet-frontend/tv3-platform'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ConnectionView } from '@tv3/store/connection/connection.view'
import { BehaviorSubject } from 'rxjs'
import { BdcContentV2Service, BdcPropertyDetails, isBdcPropertyFraud } from '@tokeet-frontend/channel-content'
import { finalize } from 'rxjs/operators'
import { Store } from '@ngrx/store'

export enum BdcPropertyDetailDialogTab {
  Details,
  Contacts,
  Amenities,
  Settings,
  Licenses,
  Photos,
  Gallery,
  Units,
  Products,
  Rates,
}

@Component({
  selector: 'app-bdc-property-detail-dialog',
  templateUrl: './bdc-property-detail-dialog.component.html',
  styleUrls: ['./bdc-property-detail-dialog.component.scss'],
})
export class BdcPropertyDetailDialogComponent implements OnInit {
  tab$ = new BehaviorSubject<BdcPropertyDetailDialogTab>(BdcPropertyDetailDialogTab.Details)
  tabs = BdcPropertyDetailDialogTab

  channel: Channel
  connection: ConnectionView

  isLoading = false
  property: BdcPropertyDetails
  isFraud = false

  constructor(
    public dialogRef: MatDialogRef<BdcPropertyDetailDialogComponent>,
    private contentService: BdcContentV2Service,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA)
    public data: { channel: Channel; connection: ConnectionView; activeTab: BdcPropertyDetailDialogTab }
  ) {
    this.channel = data.channel
    this.connection = data.connection
    this.tab$.next(data.activeTab)
  }

  ngOnInit(): void {
    // cache tags
    this.contentService.getAllPhotoTags().subscribe()
    this.isLoading = true
    this.contentService
      .getProperty(+this.connection.propertyId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (property) => {
          this.property = property
          this.isFraud = property.isPropertyFraudSuspected || property.isAccountFraudSuspected
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  close() {
    this.dialogRef.close()
  }
}
